<template>
    <div
      class="slider-wrapper w-100 d-flex align-items-center justify-content-between mb-1"
    >
      <b-button
        class="update-btn"
        :class="{ 'gray-text': internalZoom === min }"
        @click="updateZoom(-step)"
      >
        <i class="icon-remove-circle-outline m-0" />
      </b-button>

      <div class="range-container position-relative flex-grow-1 mx-2">
          <div class="range-labels d-flex justify-content-between">
              <span class="range-min">{{ internalZoom !== min ? formatter(min) : ''}}</span>
              <span class="range-max">{{ internalZoom !== max ? formatter(max) : '' }}</span>
          </div>

          <input
              type="range"
              class="form-range"
              v-model.number="internalZoom"
              :min="min"
              :max="max"
              :step="step"
              @input="emitZoom"
              ref="rangeInput"
          />

          <transition name="fade">
              <div class="thumb-value" :style="thumbPositionStyle">
              {{ displayValue }}
              </div>
          </transition>
      </div>

      <b-button
        class="update-btn"
        @click="updateZoom(step)"
        :disabled="restOfCandidate === 0"
      >
        <i class="icon-add-circle-outline m-0" />
      </b-button>
    </div>
  </template>
<script>
export default {
  name: 'RangeSlider',
  props: {
    value: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 3,
    },
    step: {
      type: Number,
      default: 0.1,
    },
    formatter: {
      type: Function,
      default: (val) => val, // örnek: 1.5 → "1.5"
    },
    restOfCandidate: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      internalZoom: this.value,
      lastValidZoom: this.value,
    };
  },
  computed: {
    thumbPositionStyle() {
      const percent = Number(((this.internalZoom - this.min) * 100) / (this.max - this.min));

      const offset = 8;

      return {
        left: `calc(${percent}% + (${offset - percent * 0.15}px))`,
      };
    },
    displayValue() {
      return this.formatter(this.internalZoom);
    },
  },
  watch: {
    value(newVal) {
      this.internalZoom = newVal;
      this.lastValidZoom = newVal;
    },
    internalZoom(newVal) {
      this.setBackgroundSize(newVal);
    },
  },
  mounted() {
    this.setBackgroundSize(this.internalZoom);
  },
  methods: {
    emitZoom() {
      const rounded = parseFloat(this.internalZoom.toFixed(3));
      if (this.restOfCandidate === 0 && rounded > this.lastValidZoom) {
        this.internalZoom = this.lastValidZoom;
        return;
      }
      const clamped = Math.min(this.max, Math.max(this.min, rounded));
      this.internalZoom = clamped;
      this.lastValidZoom = clamped;
      this.$emit('input', clamped);
    },
    updateZoom(delta) {
      let newZoom = this.internalZoom + delta;
      newZoom = Math.min(
        this.max,
        Math.max(this.min, parseFloat(newZoom.toFixed(3))),
      );
      this.internalZoom = newZoom;
      this.$emit('input', this.internalZoom);
    },
    setBackgroundSize(val) {
      this.$nextTick(() => {
        const percent = ((val - this.min) * 100) / (this.max - this.min);
        const input = this.$refs.rangeInput;
        if (input) {
          input.style.backgroundSize = `${percent}% 100%`;
        }
      });
    },
  },
};
</script>
  <style scoped lang="scss">
  .update-btn {
      background: transparent;
      font-size: 18px;
      padding: 0;

      &:disabled {
        cursor: not-allowed;
        background: transparent !important;

        i {
          color: #DE4747;
        }
      }

      &.gray-text {
        color: #C3C3C3;
      }
  }
  .range-container {
    position: relative;
    width: 100%;
  }

  .range-labels {
    position: absolute;
    top: -16px;
    left: 0;
    width: 100%;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    color: #878787;
    z-index: 1;
  }

  .range-min,
  .range-max {
    display: inline-block;
  }

  .thumb-value {
    position: absolute;
    top: -20px;
    color: #353535;
    transform: translateX(-50%);
    font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
    border-radius: 4px;
    white-space: nowrap;
    pointer-events: none;
    z-index: 1;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s ease-in-out;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .form-range {
    margin: auto;
    outline: none;
    padding: 0;
    height: 6px;
    background-color: #E5E5E5;
    background-image: -webkit-gradient(
      linear,
      50% 0%,
      50% 100%,
      color-stop(0%, #FF8D06),
      color-stop(100%, #FF8D06)
    );
    background-size: 0% 100%;
    background-repeat: no-repeat;
    border-radius: 4px;
    cursor: pointer;
    -webkit-appearance: none;
    width: 100%;
  }

  .form-range::-webkit-slider-runnable-track {
    box-shadow: none;
    border: none;
    background: transparent;
    -webkit-appearance: none;
  }

  .form-range::-webkit-slider-thumb {
    height: 15px;
    width: 15px;
    background: #fff !important;
    border: 2px solid #FF8D06;
    border-radius: 15px;
    -webkit-appearance: none;
    outline: 0 !important;
    margin-top: -1px;
    position: relative;
    z-index: 1;
  }
  </style>
